<template>
   <nav id="timelineNavigation" class="timelineNavigation "
        :class="{timelineNavigation__fixed: getterTimelineFixed,
        timelineNavigation__fixed_mini: getterTimelineFixed && getterIsMiniVariant}"
        :style="{top: `${(1+getterAlert.length)*5}rem` }">
      <div class="flex mb-3">
        <EuiIcon size="medium" name="clock"/>
        <EuiHeading :level="3" blod class="mx-auto my-auto">
          Timeline
        </EuiHeading>
      </div>
      <EuiButton v-if="isActivateButtonMoreLogs" color="info" adaptSize @click="clickMore">
       Plus de logs
      </EuiButton>
      <div class="w-full " v-for="(date) in Object.keys(content)" :key="date" >
        <a class=" flex timelineNavigation_item justify-between" :href="`#${date}`">
          <div class="inline-block pl-1">{{date}}</div>
          <div class="inline-block ml-auto mr-2">
            <EuiBadge class="" :content="content[date].length"/>
          </div>
        </a>
      </div>
    </nav>
</template>

<script>
import { mapGetters } from 'vuex';

/*
This component displays the timelineNavigation
 */
export default {
  name: 'components.logs.timelineNavigation',
  components: {
  },
  props: {
    content: {
      required: true,
      type: Object,
    },
    isActivateButtonMoreLogs: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      getterTimelineFixed: 'application/timelineFixed',
      getterIsMiniVariant: 'application/isMiniVariant',
      getterAlert: 'application/alerts',
    }),
  },
  methods: {
    clickMore() {
      this.$emit('get-more-logs');
    },
  },
};
</script>
